// src/pages/DocumentNew.tsx
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { db, auth } from '../../services/firebase'; // Your centralized Firebase exports
import { getAuth } from 'firebase/auth';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import TiptapEditor from '../../components/TiptapEditor'

const DocumentNew = () => {
const [title, setTitle] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();


const handleSave = async () => {
    const user = auth.currentUser;
    if (!user) {
      setError('You must be logged in to create a document.');
      return;
    }

    if (!title.trim()) {
      setError('Please enter a title');
      return;
    }
    if (!htmlContent.trim() || htmlContent === '<p></p>' || htmlContent === '') {
      setError('Please add some content');
      return;
    }

    setSaving(true);
    setError(null);    console.log('Saved HTML:', htmlContent)
    
    try {
      // Force a token refresh to get the latest custom claims.
      const idTokenResult = await user.getIdTokenResult(true);
      const isAuthor = idTokenResult.claims.author === true;
      const isAdmin = idTokenResult.claims.admin === true;

      if (!isAuthor && !isAdmin) {
        throw new Error('Permission denied. You must be an author or admin to create documents.');
      }
      const docRef = await addDoc(collection(db, 'documents'), {
        title: title.trim(),
        content: htmlContent,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        ownerId: auth.currentUser?.uid,  //(if you add auth check later)
        authorId: user.uid, // Store the author's UID
      });

      console.log('Document created with ID:', docRef.id);

      // Navigate to the new document's view page
      navigate(`/author/${docRef.id}`);
      // Alternative: navigate('/author'); // back to list
    } catch (err: unknown) {
      console.error('Error creating document:', err);
      let msg = 'Failed to save document.';
      if (err instanceof Error) {
        msg += `: ${err.message}`;
      }
      if ((err as any)?.code === 'permission-denied') {
        msg = 'Permission denied – check if you are signed in with author/admin role';
      }
      setError(msg);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">New Document</h1>
      
      <input
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Title..."
        className="w-full p-3 mb-6 border rounded text-2xl font-semibold"
      />

      <TiptapEditor
        onChange={setHtmlContent}
        content="<h1>My New Narrative</h1><p>Start typing...</p>"
      />

      {error && <p className="mt-4 text-red-600">{error}</p>}

      <button
        onClick={handleSave}
        disabled={saving}
        className={`mt-6 px-8 py-3 rounded text-white ${saving ? 'bg-gray-400' : 'bg-green-600 hover:bg-green-700'}`}
      >
        {saving ? 'Saving...' : 'Save'}
      </button>
    </div>
  )
}

export default DocumentNew